module.exports = __webpack_public_path__ + "media/images/workplace/patterns/6-f1373c5c198e2aa9595d7b32aa80790e.png";